import { render, staticRenderFns } from "./DataCollectionTable.vue?vue&type=template&id=56cd5eaa"
import script from "./DataCollectionTable.vue?vue&type=script&lang=ts"
export * from "./DataCollectionTable.vue?vue&type=script&lang=ts"
import style0 from "./DataCollectionTable.vue?vue&type=style&index=0&id=56cd5eaa&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports